import { PropsWithChildren } from "react";
import classnames from "classnames";
interface GenericCardProps {
  title?: string;
  bordered?: boolean;
}

export const GenericCard = ({ bordered, title, children }: PropsWithChildren<GenericCardProps>) => {
  const clName = classnames("g-card", { bordered });
  return (
    <div className={clName}>
      {title && (
        <div className="g-card--header">
          <h2 className="g-header" title={title}>
            {title}
          </h2>
        </div>
      )}
      <div>{children}</div>
    </div>
  );
};
